<div class="form-container">
  <h2>Create Vessel Subgroups</h2>

  <form [formGroup]="vesselSubgroupForm" (ngSubmit)="createVesselSubgroups()">

    <div class="vd-input-container">
      <label class="vd-lbl">Vessel Type</label>
      <div ngbDropdown #vesselDropdown="ngbDropdown">
        <div class="dropdown-wrapper no-arrow" ngbDropdownToggle
             [ngClass]="{'error-input': vesselSubgroupForm.get('vesselType')?.invalid && vesselSubgroupForm.get('vesselType')?.touched}">
          <span class="drop-txt" [ngClass]="{ 'placeholder-text': !selectedItem }">
            {{ selectedItem || 'Select Vessel Type' }}
          </span>
          <img src="../../../../../assets/danish-shipping-assets/drop-arrow-icon.svg" alt="" class="percentage-icon" />
        </div>
        <div ngbDropdownMenu aria-labelledby="Type" class="typesDropdown">
          <ng-container *ngFor="let type of vesselTypes">
            <div class="dropdown-item" ngbDropdownItem (click)="selectVesselType(type); vesselDropdown.close()">
              {{ type }}
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="vesselSubgroupForm.get('vesselType')?.invalid && vesselSubgroupForm.get('vesselType')?.touched" class="error-text">
        Vessel type is required.
      </div>
    </div>

    <div class="form-group">
      <label>Sub Type:</label>
      <input type="text" class="form-control" formControlName="subType" placeholder="Sub Type">
      <div *ngIf="vesselSubgroupForm.get('subType')?.touched && vesselSubgroupForm.get('subType')?.errors" class="text-danger">
        <small *ngIf="vesselSubgroupForm.get('subType')?.errors?.required">Sub Type is required.</small>
        <small *ngIf="vesselSubgroupForm.get('subType')?.errors?.minlength">Sub Type is too short.</small>
        <small *ngIf="vesselSubgroupForm.get('subType')?.errors?.maxlength">Sub Type is too long.</small>
      </div>
      <div *ngIf="errors.subType" class="text-danger">
        <ul><li *ngFor="let error of errors.subType">{{ error }}</li></ul>
      </div>
    </div>
<div class="form-group">
  <label>New Life Time:</label>
  <select
    class="form-control"
    formControlName="NewLifeTime"
  >
    <option value="" disabled selected>Select life time</option>
    <option *ngFor="let year of lifeTimeOptions" [value]="year">{{ year }}</option>
  </select>
  <div *ngIf="vesselSubgroupForm.get('NewLifeTime')?.touched && vesselSubgroupForm.get('NewLifeTime')?.errors" class="text-danger">
    <small *ngIf="vesselSubgroupForm.get('NewLifeTime')?.errors?.required">New Life Time is required.</small>
  </div>
</div>


    <div class="form-group">
      <label>Conversion Factor (min. 2 decimals)</label>
      <input
        type="number"
        class="form-control"
        formControlName="conversionFactor"
        step="0.01"
        min="0"
        placeholder="e.g. 1.25"
      />
      <div *ngIf="vesselSubgroupForm.get('conversionFactor')?.touched && vesselSubgroupForm.get('conversionFactor')?.errors" class="text-danger">
        <small *ngIf="vesselSubgroupForm.get('conversionFactor')?.errors?.required">Conversion Factor is required.</small>
        <small *ngIf="vesselSubgroupForm.get('conversionFactor')?.errors?.min">Conversion Factor must be positive.</small>
        <small *ngIf="vesselSubgroupForm.get('conversionFactor')?.errors?.pattern">Conversion Factor format is invalid.</small>
      </div>
      <div *ngIf="errors.conversionFactor" class="text-danger">
        <ul><li *ngFor="let error of errors.conversionFactor">{{ error }}</li></ul>
      </div>
    </div>

    <div formArrayName="subgroups" class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>SFI Code</th>
            <th>Description</th>
            <th>Emission Factor</th>
            <th>Weight Distribution</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let subgroup of subgroups.controls; let i = index" [formGroupName]="i">
            <td>
  <input
    *ngIf="subgroup.get('description')?.value !== 'Assembly'"
    type="number"
    class="form-control"
    formControlName="sfiCode"
    placeholder="SFI Code"
    readonly
  />
              <div *ngIf="subgroup.get('sfiCode')?.touched && subgroup.get('sfiCode')?.errors" class="text-danger">
                <small *ngIf="subgroup.get('sfiCode')?.errors?.required">SFI Code is required.</small>
                <small *ngIf="subgroup.get('sfiCode')?.errors?.pattern">Invalid SFI Code format.</small>
              </div>
              <div *ngIf="errors['subgroups.' + i + '.sfiCode']" class="text-danger">
                <ul><li *ngFor="let error of errors['subgroups.' + i + '.sfiCode']">{{ error }}</li></ul>
              </div>
            </td>
            <td>
              <textarea class="form-control" formControlName="description" placeholder="Description" rows="2" readonly></textarea>
              <div *ngIf="subgroup.get('description')?.touched && subgroup.get('description')?.errors" class="text-danger">
                <small *ngIf="subgroup.get('description')?.errors?.required">Description is required.</small>
              </div>
              <div *ngIf="errors['subgroups.' + i + '.description']" class="text-danger">
                <ul><li *ngFor="let error of errors['subgroups.' + i + '.description']">{{ error }}</li></ul>
              </div>
            </td>
            <td>
              <input type="number" class="form-control" formControlName="coefficient" placeholder="Emission factor" min="0" />
              <div *ngIf="subgroup.get('coefficient')?.touched && subgroup.get('coefficient')?.errors" class="text-danger">
                <small *ngIf="subgroup.get('coefficient')?.errors?.required">Emission Factor is required.</small>
                    <small *ngIf="subgroup.get('coefficient')?.errors?.min">Emission Factor must be ≥ 0.</small>
                <small *ngIf="subgroup.get('coefficient')?.errors?.pattern">Emission Factor must be numeric.</small>
              </div>
              <div *ngIf="errors['subgroups.' + i + '.coefficient']" class="text-danger">
                <ul><li *ngFor="let error of errors['subgroups.' + i + '.coefficient']">{{ error }}</li></ul>
              </div>
            </td>
            <td>
              <input type="number" class="form-control" formControlName="weightDistribution" placeholder="Weight %"      min="0"
    max="100" *ngIf="subgroup.get('description')?.value !== 'Assembly'" />
              <div *ngIf="subgroup.get('weightDistribution')?.touched && subgroup.get('weightDistribution')?.errors" class="text-danger">
                <small *ngIf="subgroup.get('weightDistribution')?.errors?.required">Weight Distribution is required.</small>
                <small *ngIf="subgroup.get('weightDistribution')?.errors?.min || subgroup.get('weightDistribution')?.errors?.max">
                  Weight Distribution must be a percentage between 0 and 100.
                </small>
              </div>
              <div *ngIf="errors['subgroups.' + i + '.weightDistribution']" class="text-danger">
                <ul><li *ngFor="let error of errors['subgroups.' + i + '.weightDistribution']">{{ error }}</li></ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


<div
  class="mt-2 mb-3"
  [ngClass]="isWeightDistributionValid ? 'text-success' : 'text-danger'"
>
  Current total: {{ weightDistributionTotal }}%
</div>


    <div *ngIf="subgroups.errors?.weightDistributionSumExceeded" class="text-danger mb-3">
      Total weight distribution cannot exceed 100%.
    </div>
<div *ngIf="subgroups.errors?.weightDistributionSumNot100 && isAnyWeightDistributionTouched()" class="text-danger mb-3">
  Total weight distribution must be exactly 100%.
</div>



    <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || vesselSubgroupForm.invalid">
      {{ isSubmitting ? 'Submitting...' : 'Create Vessel Subgroups' }}
    </button>

  </form>
</div>
